import React from "react";
import Colors from "~/constants/colors";
import Text from "../Text";

type Props = {
  data: {
    last_24h_sale_count: number;
    last_24h_in_cart_count: number;
    last_24h_view_count: number;
  };
};

const ProductIndex = ({ data }: Props) => {
  if (!data) return null;
  const result = () => {
    if (data?.last_24h_sale_count) {
      const text =
        data.last_24h_sale_count === 1
          ? "{{number}} sale in the last 24 hours"
          : "{{number}} sales in the last 24 hours";
      const number =
        data.last_24h_sale_count > 20 ? "20+" : data.last_24h_sale_count + "";
      return text?.replace("{{number}}", number);
    } else if (
      !!data?.last_24h_in_cart_count &&
      data?.last_24h_in_cart_count >= 2
    ) {
      const text =
        data.last_24h_in_cart_count === 1
          ? "In {{number}} cart"
          : "In {{number}} carts";
      const number =
        data.last_24h_in_cart_count > 20
          ? "20+"
          : data.last_24h_in_cart_count + "";
      return text?.replace("{{number}}", number);
    } else if (!!data?.last_24h_view_count && data?.last_24h_view_count >= 2) {
      const text =
        data.last_24h_view_count === 1
          ? "{{number}} view in the last 24 hours"
          : "{{number}} views in the last 24 hours";
      const number =
        data.last_24h_view_count > 20 ? "20+" : data.last_24h_view_count + "";
      return text?.replace("{{number}}", number);
    } else {
      return null;
    }
  };

  return (
    <Text
      type="label-2"
      style={{ color: Colors.ACCENT_GREEN_50, fontWeight: 700 }}
    >
      {result()}
    </Text>
  );
};

export default ProductIndex;
